import SimpleProLandingPage from './SimpleProLandingPage';

export default SimpleProLandingPage;
